<template>
    <v-container>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" :info="info"
            v-on:close="showDismissibleAlert = false" />


        <v-row>
            <v-col class="d-flex justify-space-between mb-5 item-center ">
                <h3>Add Machines to the report</h3>
                <v-spacer></v-spacer>
                <v-card class="pa-2" :color="$store.getters.getColorPalette().backgroundColorCode">
                    <v-icon>mdi-file</v-icon> {{ report.report_id }}
                </v-card>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="isValid">
            <v-row>
                <v-col>
                    <v-text-field v-if="!loading" v-model="form.label" :counter="30" :rules="nameRules"
                        :label="$store.getters.getTextMap().label" required dense outlined />
                </v-col>
                <v-col>
                    <v-select v-if="!loading" v-model="workspace" :items="workspaceOptions"
                        :label="$store.getters.getTextMap().workspaces" dense outlined item-text="label"
                        item-value="value" required :rules="objectRules"
                        :menu-props="{ dark: $store.getters.getColorPalette().isDark }" />
                </v-col>
                <v-col>
                    <v-select v-if="!loading" v-model="form.machine_id" :items="machineOptions"
                        :label="$store.getters.getTextMap().machines" dense outlined item-text="label"
                        item-value="value" required :rules="objectRules"
                        :menu-props="{ dark: $store.getters.getColorPalette().isDark }">
                    </v-select>
                </v-col>

                <v-col>
                    <v-btn :color="$store.getters.getColorPalette().submitbtnColor" @click="addToList" class="mx-5">
                        {{ $store.getters.getTextMap().add }}
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col v-if="MachinesFromReport.length > 0">
                    <template>
                        <v-simple-table dense :color="$store.getters.getColorPalette().backgroundColorName"
                            :dark="$store.getters.getColorPalette().isDark">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-center pa-3">
                                            <h2>
                                                Label
                                            </h2>
                                        </th>
                                        <th class="text-center pa-3">
                                            <h2>
                                                Machine
                                            </h2>
                                        </th>
                                        <th class="text-center pa-3"
                                            v-if="$store.state.user && $store.state.settingMode && $store.getters.getAccessByLevels(['betaaccess'])">
                                            <h2>
                                                Delete
                                            </h2>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in MachinesFromReport" :key="item.name">
                                        <td class="text-center pa-3">{{ item.label }}</td>
                                        <td class="text-center pa-3"> {{ getMachineName(item.machine_id) }} </td>
                                        <td class="text-center pa-3"
                                            v-if="$store.state.user && $store.state.settingMode && $store.getters.getAccessByLevels(['betaaccess'])">
                                            <v-btn small icon color="red" outlined>
                                                <DeleteConfirmation v-on:confirm="deleteMachineFromReport(item)"
                                                    title="Delete Confirmation"
                                                    description="Are you sure you want to delete this?">
                                                    <v-icon small>mdi-delete</v-icon>
                                                </DeleteConfirmation>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </template>
                </v-col>
            </v-row>
        </v-form>





    </v-container>
</template>

<script>
import axios from "axios";
import InfoAlert from "@/components/InfoAlert";
import DeleteConfirmation from "@/components/DeleteConfirmation";


export default {
    name: "EnergyAnalysisReportDetails",
    props: ["report"],
    components: {
        InfoAlert,
        DeleteConfirmation,

    },
    data() {
        return {
            file: "",
            showDismissibleAlert: false,
            info: '',
            isValid: false,
            loading: false,
            nameRules: [
                (v) => !!v || this.$store.getters.getTextMap().name_is_required,
                (v) => /\S+/.test(v) || this.$store.getters.getTextMap().name_is_required,
                (v) =>
                    (v && v.length <= 30 && v.length > 0) ||
                    this.$store.getters.getTextMap().name_must_be_less_than_30_characters,
            ],
            tableData: [],
            workspace: null,
            form: {
                label: null,
                machine_id: null
            },
            machineOptions: [],
            objectRules: [(v) => !!v || "Required"],
            selectAll: false,
            showEdit: false
        };
    },
    computed: {
        workspaceOptions() {
            let op = [];
            let g = this.$store.state.workspaces;
            for (let i of g) {
                op.push({ value: i, label: i.name });
            }
            return op;
        },
    },
    methods: {
        getMachineName(machine_id) {
            let machineDetails = this.$store.getters.getMachineById(machine_id)
            return machineDetails.name ? machineDetails.name : machine_id
        },
        getMachineList() {
            let op = [];
            if (this.workspace) {
                let payload = {
                    workspace_id: this.workspace.workspace_id,
                };

                this.loading = true;
                axios
                    .post(
                        this.$store.state.api + "getMachinesByWorkspace",
                        payload,
                        { headers: { Authorization: "Bearer " + this.$store.state.jwt } }
                    )
                    .then((response) => {
                        if (response.data.status == "success") {
                            let machines = response.data.machines;
                            for (let i of machines) {
                                if (i && i.name) {
                                    op.push({ value: i.machine_id, label: i.name });
                                } else {
                                    op.push({ value: i.machine_id, label: i.machine_id });
                                }
                            }
                        } else {
                            this.info = response.data.msg;
                            this.showDismissibleAlert = true;
                        }
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.info = error;
                        this.showDismissibleAlert = true;
                        this.loading = false;
                    });
            }
            this.machineOptions = op;
        },
        selectAllMachines() {
            if (this.selectAll) {
                this.machines = this.machineOptions.map((m) => m.value);
            } else {
                this.machines = [];
            }
        },

        addToList() {
            this.$refs.form.validate();
            if (this.isValid) {
                this.loading = true
                let payload = { ...this.form };
                payload["report_id"] = this.report.report_id;
                axios
                    .post(
                        this.$store.state.api + "addEnergyAnalysisMachineToList",
                        payload,
                        {
                            headers: { Authorization: "Bearer " + this.$store.state.jwt },
                        }
                    )
                    .then((response) => {
                        console.log(response);
                        if (response.data.status == "success") {
                            this.loading = false
                            this.showDismissibleAlert = true
                            this.info = "Machine added Successfully"
                        } else {
                            this.loading = false
                            this.showDismissableAlert = false
                            this.info = response.data.msg
                        }
                    });

            }
        },
        deleteMachineFromReport(machine) {
            if (machine) {
                this.loading = true
                let payload = Object.assign({}, machine)
                axios.post(this.$store.state.api + "deleteEnergyAnalysisMachineToList", payload, {
                    headers: { Authorization: 'Bearer ' + this.$store.state.jwt }
                }).then((response) => {
                    if (response.data.status == "success") {
                        this.loading = false
                        this.showDismissibleAlert = true
                        this.info = "Report Deleted Successfully"
                    } else {
                        this.loading = false
                        this.showDismissibleAlert = true
                        this.info = response.data.msg
                    }
                })
            }
        },
    },
    watch: {
        workspace() {
            this.getMachineList();
        },
    },
};
</script>

<style scoped></style>